import request from '@/utils/request'

const baseUrl = '/erp/sales/allowance'

export const pageSalesAllowance = params => request({ url: baseUrl + '/page', method: 'get', params })
export const getSalesAllowance = id => request({ url: baseUrl + '/detail', method: 'get', params: { id } })
export const listAllowanceOutboundSources = params => request({ url: baseUrl + '/outbound-sources', method: 'get', params })
export const listAllowanceOutboundLines = params => request({ url: baseUrl + '/outbound-lines', method: 'get', params })
export const createSalesAllowance = data => request({ url: baseUrl + '/add', method: 'post', data })
export const updateSalesAllowance = data => request({ url: baseUrl + '/edit', method: 'post', data })
export const auditSalesAllowance = id => request({ url: baseUrl + '/audit', method: 'post', data: { id } })
export const reverseAuditSalesAllowance = id => request({ url: baseUrl + '/reverse-audit', method: 'post', data: { id } })
export const deleteSalesAllowance = id => request({ url: baseUrl + '/delete', method: 'post', data: { id } })
